<app-card class="comunicado" [titulo]="comunicado.titulo" data-testid="card-comunicado-titulo">
  <div text [innerHTML]="comunicado.descricao" data-testid="card-comunicado-descricao"></div>
</app-card>
